import { render, staticRenderFns } from "./a21.vue?vue&type=template&id=50621772&scoped=true"
import script from "./a21.vue?vue&type=script&lang=js"
export * from "./a21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50621772",
  null
  
)

export default component.exports